<div (click)="toggleCheckbox()" class="aml-checkbox">
  <input [value]="isSelected" type="checkbox" [checked]="isSelected" [disabled]="disabled" />
  <div [ngClass]="{'yes': isSelected === true, 'cancelled': isSelected === false, 'never': isSelected === null}">
    <label></label>
  </div>
</div>
